@if (allowedFileExtensions && showUi) {
    <div
        class="detail-page-card"
        [class.m-0]="noMargin"
        [class.compact-document-manager]="compactMode"
        [class.no-documents]="Documents.length == 0"
        fileDrop
        (fileDrop)="fileDropHandler($event)"
        [allowedExtensions]="allowedFileExtensions"
        [allowDrop]="permissions.canAddDocument"
    >
        @if (Documents.length > 0) {
            @if (!hideLabel && Label) {
                <div class="detail-page-card-title">{{ Label }}</div>
            }
            @if (!hideAddButton || !hideGenerateButton) {
                <div class="detail-page-card-actions">
                    @if (!hideAddButton) {
                        <button
                            data-uiid="documentmanager-adddocument"
                            class="btn btn-raised"
                            (click)="openEdit()"
                            [disabled]="disabled || !permissions.canAddDocument"
                        >
                            <i class="fas fa-plus-circle"></i>
                            <span>{{ 'addDocument' | t }}</span>
                        </button>
                    }
                    @if (!hideGenerateButton) {
                        <button
                            data-uiid="documentmanager-generatedocument"
                            class="btn btn-raised"
                            (click)="openGenerate()"
                            [disabled]="disabled || !permissions.canAddDocument"
                        >
                            <i class="fas fa-plus-circle"></i>
                            <span>{{ 'generateDocument' | t }}</span>
                        </button>
                    }
                </div>
            }

            <div class="document-grid">
<!-- Syncfusion reads column headers once, when the grid is created. The pipe yields ""
                     until the scope has loaded, so the grid renders only after that, and keying it on
                     the translated headers rebuilds it after a language switch or a new
                     ExtraFieldColumnConfig. -->
                @let nameHeader = 'nameColumn' | t;
                @let descriptionHeader = 'descriptionColumn' | t;
                @let userHeader = 'userColumn' | t;
                @let dateUploadedHeader = 'dateUploadedColumn' | t;
                @let documentTypeHeader = 'documentTypeColumn' | t;
                @let versionsHeader = 'versionsColumn' | t;
                @if (nameHeader) {
                @for (gridKey of [[nameHeader, descriptionHeader, userHeader, dateUploadedHeader, documentTypeHeader, versionsHeader, gridVersion].join('|')]; track gridKey) {
                <ejs-grid
                    [dataSource]="Documents"
                    [filterSettings]="_filterOptions"
                    [sortSettings]="_sortColumnOptions"
                    [showColumnMenu]="true"
                    [allowReordering]="true"
                    [allowResizing]="true"
                    [allowFiltering]="true"
                    [allowSorting]="true"
                    [enableHover]="true"
                    (recordDoubleClick)="openEdit($event.rowData)"
                    #ejGrid
                >
                    <e-columns>
                        <e-column field="Name" [headerText]="nameHeader">
                            <ng-template #template let-data>
                                @if (!data.IsNew && !data.Edited && !data.Deleted) {
                                    @if (data.msFileIcon) {
                                        <span class="mat-icon-workaround">
                                            <mat-icon [svgIcon]="data.msFileIcon"></mat-icon>
                                        </span>
                                    } @else {
                                        <i class="fas fa-{{ data.FileIcon }}"></i>
                                    }
                                }
                                @if (data.IsNew) {
                                    <i class="fas fa-plus"></i>
                                }
                                @if (data.Edited) {
                                    <i class="fas fa-pencil"></i>
                                }
                                @if (data.Deleted) {
                                    <i class="fas fa-times"></i>
                                }

                                <span class="document-name ms-2" [class.red]="data.Deleted">
                                    {{ data.Name }}
                                    @if (data.Changed) {
                                        <i>{{ 'edited' | t }}</i>
                                    }
                                </span>
                            </ng-template>
                        </e-column>
                        <e-column
                            field="Description"
                            [headerText]="descriptionHeader"
                            [visible]="false"
                        ></e-column>
                        <e-column
                            field="Username"
                            [headerText]="userHeader"
                            [visible]="!compactMode"
                        ></e-column>
                        <e-column
                            [headerText]="dateUploadedHeader"
                            [visible]="!compactMode"
                        >
                            <ng-template #template let-data>{{
                                data.Date | dateTimeFormat: true
                            }}</ng-template>
                        </e-column>
                        <e-column
                            field="DocumentType"
                            [headerText]="documentTypeHeader"
                            [visible]="!compactMode"
                        ></e-column>
                        <e-column
                            field="Version"
                            [headerText]="versionsHeader"
                            [visible]="false"
                        ></e-column>

                        @for (col of ExtraFieldColumnConfig; track col.fieldName) {
                            <e-column
                                [field]="col.fieldName"
                                [headerText]="col.prettyName"
                                [width]="col.columnWidth"
                                [visible]="!col.hidden"
                            >
                            </e-column>
                        }

                        <e-column
                            width="40"
                            textAlign="Center"
                            [allowEditing]="false"
                            [allowResizing]="false"
                        >
                            <ng-template #template let-data>
                                <i
                                    class="fas fa-bars"
                                    mat-icon-button
                                    [matMenuTriggerFor]="docManagerFileMenu"
                                ></i>
                                <mat-menu #docManagerFileMenu="matMenu">
                                    @if (!data.IsNew) {
                                        @if (!data.Deleted) {
                                            @if (data.WopiViewable) {
                                                <button
                                                    mat-menu-item
                                                    (click)="
                                                        openEmbedView(data);
                                                        cerrixSlideOverWopi.show();
                                                        $event.stopPropagation()
                                                    "
                                                >
                                                    <mat-icon [svgIcon]="data.msAppIcon"></mat-icon>
                                                    <span>{{ 'viewInOfficeForTheWeb' | t }}</span>
                                                </button>
                                            }
                                            @if (!disabled && AllowEdit && data.WopiEditable) {
                                                <button
                                                    mat-menu-item
                                                    (click)="
                                                        openEditorInWindow(data);
                                                        $event.stopPropagation()
                                                    "
                                                >
                                                    <mat-icon [svgIcon]="data.msAppIcon"></mat-icon>
                                                    <span>{{ 'editInOfficeForTheWeb' | t }}</span>
                                                </button>
                                            }
                                        }
                                        @if (data.Name.endsWith(".pdf")) {
                                            <button
                                                mat-menu-item
                                                (click)="openDocumentViewer(data)"
                                            >
                                                <mat-icon
                                                    fontSet="fas"
                                                    fontIcon="fa-file-pdf"
                                                ></mat-icon>
                                                <span>{{ 'openPdfViewer' | t }}</span>
                                            </button>
                                        }
                                    }

                                    <a
                                        mat-menu-item
                                        [href]="'api/documents/manager/' + data.Guid + '/data'"
                                        target="_blank"
                                    >
                                        <mat-icon><i class="fas fa-download"></i></mat-icon>
                                        <span>{{ 'download' | t }}</span>
                                    </a>
                                    @if (!disabled && data.CanDelete && AllowDelete) {
                                        <button mat-menu-item (click)="toggleDelete(data.Guid)">
                                            @if (data.Deleted) {
                                                <mat-icon><i class="fas fa-undo"></i></mat-icon>
                                            } @else {
                                                <mat-icon><i class="fas fa-trash"></i></mat-icon>
                                            }

                                            <span>{{
                                                (data.Deleted
                                                    ? "undoDelete"
                                                    : "delete"
                                                ) | t
                                            }}</span>
                                        </button>
                                    }
                                </mat-menu>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
                }
                }
            </div>
        } @else {
            <div class="no-documents-area">
                <div class="no-documents-text">
                    <i class="fas fa-info-circle fa-fw me-2 primary-color"></i>
                    <span class="fw-bold">{{ 'noDocumentsUploaded' | t }}</span>
                </div>
                @if (!hideAddButton && !disabled && permissions.canAddDocument) {
                    <div class="add-first-document-section">
                        <div>
                            <button class="btn btn-primary" (click)="openEdit()">
                                <span>{{ 'addNew' | t }}</span>
                                <i class="far fa-plus ms-2"></i>
                            </button>
                            @if (!hideGenerateButton) {
                                <button class="btn btn-primary" (click)="openGenerate()">
                                    <span>{{ 'generateNew' | t }}</span>
                                    <i class="far fa-plus ms-2"></i>
                                </button>
                            }
                        </div>
                        <span>{{ 'or' | t }}</span>
                        <span class="fw-bold primary-color">
                            <i class="far fa-arrow-to-bottom me-2"></i>
                            <span>{{ 'dragDocumentsHere' | t }}</span>
                        </span>
                    </div>
                }
            </div>
        }
    </div>
}

<cerrix-slide-over-wopi
    #cerrixSlideOverWopi
    [title]="slideOutTitle"
    [wopiData]="slideOutContent"
></cerrix-slide-over-wopi>
